import { LINK_CG_TERM_TAX_FORM } from '../form-tcg-types';
import { showToast } from '../../../toasts';

import PostCardGroupTerminalTax from '../../../../routes/post-tax-cardgroup-terminal';

/**
 * Gets a list of selected taxes and calls the postCardGroupTerminalTax func
 * 
 * @param {string} cardgroupID the cord group id
 * @param {string} terminalID the terminal id
 * 
 * @returns void
 */
export const addTaxCardGroupTerminal = async (cardgroupID: string, terminalID: string) => {
  const taxList = document.querySelectorAll<HTMLElement>('[data-taxid]');
  let finalList: string = '';

  if(taxList) {
    taxList.forEach(e => {
      const taxId = e.getAttribute('data-taxid');
      finalList += taxId + ',';
    });
  }

  const awsData = {
    cardGroupID: +cardgroupID,
    terminalID: terminalID,
    taxIdArray: finalList.slice(0, -1)
  }

  const { statusCode, body } = await PostCardGroupTerminalTax(awsData);

  if( statusCode === 200 ) {
    showToast('aafp_toast', `${LINK_CG_TERM_TAX_FORM.cgTTcardgroup.value} has been updated`);
  } else {
    showToast('aafp_toast-alert', `Error updating terminal list`);
    console.error(body);
  }   
}